module.exports = __webpack_public_path__ + "img/sign_230490689_1.93b78aa0.png";